import { useState } from 'react';

import { Grid } from '@mui/material';
import { FieldOwnerState } from '@mui/x-date-pickers';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';

import { CissAutoComplete } from 'components/autocompletes/CissAutoComplete';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function FilterEstatisticas() {
    const [filterDocumento, setFilterDocumento] = useState<FilterValuesProps>({
        property: 'dsTipoDocumento',
        operator: 'like',
        value: null,
        idProperty: 'dsTipoDocumento',
    });

    const [filterDtInicial, setFilterDtInicial] = useState<FilterValuesProps>({
        property: 'dtInicial',
        operator: 'eq',
        value: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        required: 'É necessário selecionar um intervalo de tempo',
    });

    const [filterDtFinal, setFilterDtFinal] = useState<FilterValuesProps>({
        property: 'dtFinal',
        operator: 'eq',
        value: new Date(),
        required: 'É necessário selecionar um intervalo de tempo',
    });

    return (
        <Filter
            filters={[
                { value: filterDocumento, setter: setFilterDocumento },
                { value: filterDtInicial, setter: setFilterDtInicial },
                { value: filterDtFinal, setter: setFilterDtFinal },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissAutoComplete
                    value={filterDocumento.value}
                    onChange={(e, value) => {
                        setFilterDocumento({ ...filterDocumento, value });
                    }}
                    requestOptions={{
                        url: '/gestao/tipodocumento',
                        columns: 'idTipoDocumento,dsTipoDocumento',
                    }}
                    isOptionEqualToValue={(option, value) => option && value && option.idTipoDocumento === value.idTipoDocumento}
                    multiple={false}
                    optionStringTemplate={'<strong>{idTipoDocumento}</strong> - {dsTipoDocumento}'}
                    selectedStringTemplate={'{idTipoDocumento} - {dsTipoDocumento}'}
                    label={'Tipo de documento'}
                />
            </Grid>
            <Grid sx={{ width: '100%', flex: 1 }}>
                <DateRangePicker
                    value={[filterDtInicial.value ?? null, filterDtFinal.value ?? null]}
                    onChange={([startDate, endDate]) => {
                        setFilterDtInicial({ ...filterDtInicial, value: startDate });
                        setFilterDtFinal({ ...filterDtFinal, value: endDate });
                    }}
                    slots={{ field: MultiInputDateRangeField }}
                    slotProps={{
                        field: { dateSeparator: 'até' },
                        textField: ({ position }: FieldOwnerState & { position?: 'start' | 'end' }) => ({
                            label: position === 'start' ? 'Data início' : 'Data fim',
                            autoComplete: 'off',
                        }),
                    }}
                />
            </Grid>
        </Filter>
    );
}
